<template>
    <div class="display-inline-flex">
        <div :class="{'stack-s': !fluid}">
            <v-popper-select
                class="inline-xs"
                label="Week"
                :options="weekOptions"
                :value="weekType"
                :validate="validate.week"
                @input="updateWeek"/>
            <v-popper-select
                label="Day"
                :options="weekDaysOptions"
                :value="day"
                :validate="validate.day"
                @input="updateDay"/>
        </div>
        <div class="display-flex">
                    <span v-if="timeIsRequired" class="inline-s text-muted">
                        &nbsp;at
                    </span>
            <span v-else class="inline-s text-muted">
                        (Optional Time)
                    </span>
            <v-date-input
                class="inline-m"
                type="time"
                :value="time"
                :validate="validate.time"
                @input="updateTime">
                <template slot="hours-input" slot-scope="hours">
                    <v-popper-select
                        label="Hours"
                        :options="prepareDateTimeOptions(hours.options)"
                        :value="hours.value"
                        @input="value => inputTime('hours', value, hours.input)"/>
                </template>
                <template slot="minutes-input" slot-scope="minutes">
                    <v-popper-select
                        label="Minutes"
                        :options="prepareDateTimeOptions(minutes.options)"
                        :value="minutes.value"
                        @input="value => inputTime('minutes', value, minutes.input)"/>
                </template>
            </v-date-input>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import _ from '@/common/helpers';
    import {vDateInput, vPopperSelect} from '@/components/form';
    import {weekTypes} from '@/components/inline-time-period/week-types';
    import prepareDateTimeOptions from '@/components/inline-time-period/prepare-datetime-options';
    import PeriodComponentMixin from '@/components/inline-time-period/period-component-mixin';

    export default {
        name: 'day-of-week',
        components: {
            vPopperSelect, vDateInput,
        },
        mixins: [PeriodComponentMixin],
        props: {
            weekType: {},
            day: {},
            time: {},
        },
        computed: {
            timeIsRequired() {
                return this.validate.time.required === true;
            },
            weekOptions() {
                return Object.values(weekTypes).map(value => ({
                    label: _.unKebabCase(value),
                    value,
                }));
            },
            weekDaysOptions() {
                return moment.weekdays().map(label => ({
                    label,
                    value: label,
                }));
            },
        },
        methods: {
            prepareDateTimeOptions(options) {
                return prepareDateTimeOptions(options);
            },
            updateWeek(week) {
                this.$emit('update', {week});
            },
            updateDay(day) {
                this.$emit('update', {day});
            },
            updateTime(time) {
                this.$emit('update', {time});
            },
            inputTime(name, value, handler) {
                if (!value) {
                    this.$emit('update', {time: null});
                } else {
                    handler(value);
                }
            },
        },
    };
</script>
